import { createContext, useContext, useEffect, useState } from "react";
import { isStandalone } from "./installation.js";

const PwaContext = createContext(null);

export function PwaProvider({ children }) {
  const [installed, setInstalled] = useState(isStandalone);
  const [installPrompt, setInstallPrompt] = useState(null);
  useEffect(() => {
    const display = window.matchMedia("(display-mode: standalone)");
    function beforeInstall(event) {
      if (window.Telegram?.WebApp?.initData) return;
      event.preventDefault();
      setInstallPrompt(event);
    }
    function onInstalled() { setInstalled(true); setInstallPrompt(null); }
    function onDisplayChange() { setInstalled(isStandalone()); }
    window.addEventListener("beforeinstallprompt", beforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    display.addEventListener("change", onDisplayChange);
    return () => {
      window.removeEventListener("beforeinstallprompt", beforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
      display.removeEventListener("change", onDisplayChange);
    };
  }, []);
  return <PwaContext.Provider value={{ installed, installPrompt, clearPrompt: () => setInstallPrompt(null) }}>{children}</PwaContext.Provider>;
}

export function usePwaInstallation() {
  return useContext(PwaContext);
}
